import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as R from 'ramda';
import {DownloadLettersAndReco} from '../../actions/backoffice/impression';

// import { AddPartner } from './../_common/AddPartner';

export const ImpressionTableLine = ({userLetter, user, letter, selectDocuments, setSelectedDocuments}) => {
    return (
        <li className="card p-2 mt-1 print-shadow">
            <h2 className="sr-only visually-hidden">List: item</h2>
            <div className="row gx-2 gy-1 align-items-center">
                <div className="col-sm-4 col-md-3 col-xl-2">
                    <div className="row g-1 align-items-center">
                        <div className="col-1 col-sm-2 col-md-3 col-xl-2">
                            <button className="btn btn-item btn-icon btn-stage-secondary shadow-none rounded" onClick={(e) => {
                                e.preventDefault();
                                if (selectDocuments.includes(userLetter.id)) {
                                    setSelectedDocuments(selectDocuments.filter(d => d !== userLetter.id))
                                } else {
                                    setSelectedDocuments([...selectDocuments, userLetter.id])
                                }
                            }}><i className={"eva fs-root lh-1" + (selectDocuments.includes(userLetter.id) ? " eva-checkmark-square-2 text-secondary" : " eva-square-outline")} data-toggle="tooltip" data-placement="bottom" data-template='<div class="tooltip tooltip-white-secondary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 rounded font-weight-regular lh-root"></div></div>' title="Sélectionner le document"></i></button>
                        </div>
                        <div className="col">
                            <div className="h5 ls-1 my-auto text-truncate">{user.processNumber}</div>
                        </div>
                    </div>
                </div>
                <div className="col-sm col-md-4 col-lg-5 text-md-left">
                    <div className="h5 ls-1 my-auto o-70">{letter.name.substring(letter.name.indexOf('-') + 1)}</div>
                </div>
                {/* <div className="col-auto col-md-1">
                    <div className="h5 ls-1 my-auto o-70 container-press ml-auto">Engie</div>
                </div> */}
                <div className="col-sm col-md-4 col-lg text-md-right">
                    <div className="h5 ls-1 my-auto container-press ml-auto">{userLetter.postId}</div>
                </div>
                {/* <div className="col-auto col-md-1 text-md-right">
                    <div className="h5 ls-1 my-auto container-press ml-auto">-</div>
                </div> */}
                <div className="col-12 d-md-none">
                    <hr className="my-1" />
                </div>
                <div className="col-md-1 ml-auto flex-row justify-content-md-end">
                    {/* <div className="badge alert-bagde text-uppercase btn-alert-danger font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate mr-2"><span className="aling-middle text-truncate">A traiter</span></div> */}
                    <button type="button" className="btn btn-icon btn-stage-info shadow-none p-0 rounded-sm" data-toggle="tooltip" title="Télécharger document" data-template='<div class="tooltip tooltip-white-info" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'
                    onClick={(e) => {
                        e.preventDefault();
                        DownloadLettersAndReco([{id: userLetter.id}]);
                    }

                    }>
                        <i className="eva eva-file-text-outline align-middle h4 lh-1 m-auto"></i>
                        <span className="aling-middle text-truncate d-md-none mx-1">Télécharger document</span>
                    </button>
                    {/* <button className="btn btn-item btn-icon btn-stage-secondary shadow-none rounded px-2" onClick={(e) => {
                        e.preventDefault();
                        if(selectDocuments.includes(userLetter.id)){
                            setSelectedDocuments(selectDocuments.filter(d => d !== userLetter.id))
                        }else{
                            setSelectedDocuments([...selectDocuments, userLetter.id])
                        }
                    }}><i className={"eva fs-root lh-1" + (selectDocuments.includes(userLetter.id) ? " eva-checkmark-square-2 text-secondary" : " eva-square-outline")} data-toggle="tooltip" data-placement="bottom" data-template='<div class="tooltip tooltip-white-secondary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 rounded font-weight-regular lh-root"></div></div>' title="Sélectionner le document"></i></button> */}

                </div>
            </div>
        </li>
    )
}